export var mapBy = function (list, getKey) {
    var map = new Map();
    list.forEach(function (item) {
        var key = getKey(item);
        var collection = map.get(key);
        if (collection !== undefined) {
            throw new Error("multiple items for key ".concat(key.toString()));
        }
        map.set(key, item);
    });
    return map;
};
